import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useI18n } from "../../../../../contexts";
import { FormHeadline } from "../../../headline";
import { FormTcfVendorFieldGeneralDataProcessingInCountries, FormTcfVendorFieldGeneralDataProcessingInCountriesSpecialTreatments, FormTcfVendorFieldGeneralLegalAddress, FormTcfVendorFieldGeneralPrivacyPolicyUrl, FormTcfVendorFieldGeneralProvider, FormTcfVendorFieldGeneralStatus, FormTcfVendorFieldGeneralTerritorialScope } from ".";
import { FormLayoutTcfVendor } from "../..";
const FormTcfVendorFieldGeneralCompose = ()=>{
    const { __ } = useI18n();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FormHeadline, {
                offset: FormLayoutTcfVendor.labelCol.span,
                children: __("General vendor configuration")
            }),
            /*#__PURE__*/ _jsx(FormTcfVendorFieldGeneralProvider, {}),
            /*#__PURE__*/ _jsx(FormTcfVendorFieldGeneralStatus, {}),
            /*#__PURE__*/ _jsx(FormTcfVendorFieldGeneralLegalAddress, {}),
            /*#__PURE__*/ _jsx(FormTcfVendorFieldGeneralPrivacyPolicyUrl, {}),
            /*#__PURE__*/ _jsx(FormTcfVendorFieldGeneralTerritorialScope, {}),
            /*#__PURE__*/ _jsx(FormTcfVendorFieldGeneralDataProcessingInCountries, {}),
            /*#__PURE__*/ _jsx(FormTcfVendorFieldGeneralDataProcessingInCountriesSpecialTreatments, {})
        ]
    });
};
export { FormTcfVendorFieldGeneralCompose };
